// extracted by mini-css-extract-plugin
export var active = "_cw-7";
export var container = "_cw-0";
export var evenWidth = "_cw-4";
export var large = "_cw-5";
export var outlet = "_cw-8";
export var slide = "_cw-2";
export var small = "_cw-6";
export var tab = "_cw-3";
export var tabs = "_cw-1";